// extracted by mini-css-extract-plugin
export default {"navigation":"styles_navigation__j-kcx","active_icon":"styles_active_icon__T5I66"};